import Vue from 'vue'
import service from '../services/logs-service'

export function useLogs() {
  const state = Vue.observable({
    items: [],
    currentPage: 1,
    lastPage: 1,
    loading: false
  })

  async function getLogs(params = {}) {
    state.loading = true
    try {
      const response = await service.getLogs(params)
      state.items = response.logs.current_page === 1
        ? [...response.logs.data]
        : [...state.items, ...response.logs.data]
      state.currentPage = response.logs.current_page
      state.lastPage = response.logs.last_page
      state.loading = false
      return { success: true, response }
    } catch (err) {
      return { success: false, error: err }
    } finally {
      state.loading = false
    }
  }

  return { state, getLogs }
}
